import React, { FC } from 'react';
import cn from 'classnames/bind';

import { SubtitlesTracksList } from '@/scenarios/legacy-player/components/PlayerSkin/parts/SubtitlesTracksList/SubtitlesTracksList';
import { SubtitlesTracksListProps } from '@/scenarios/legacy-player/components/PlayerSkin/parts/SubtitlesTracksList/SubtitlesTracksList.types';

import styles from '../Tracks.module.css';

const cx = cn.bind(styles);

type Props = Pick<
    SubtitlesTracksListProps,
    | 'currentTextTrack'
    | 'textTracksWithDisableOption'
    | 'handleSelectTextTrack'
    | 'hasMoreSubtitles'
    | 'showAllSubtitles'
>;

export const SubtitlesList: FC<Props> = (props) => (
    <SubtitlesTracksList
        className={cx('subtitles')}
        titleClassName={cx('title')}
        bodyClassName={cx('body')}
        {...props}
    />
);
